import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ArrowDown({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ArrowDown</title>
      <path
        d="M12 4L12 20M12 20L6 14M12 20L18 14"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
